import * as React from 'react';

import { Button, Menu } from '@rematter/ui-web';
import { MoreHorizontal } from 'lucide-react';

import {
  BrokeredOrderDetailRecord,
  BrokeredOrderRecord,
} from '../../types/brokeredOrder';

import { useBrokeredOrderMenuItems } from './hooks/useBrokeredOrderMenuItems';

export type BrokeredOrderActionMenuProps = {
  order: BrokeredOrderRecord | BrokeredOrderDetailRecord;
  onVoid?: (id: string) => void;
  onFinish?: (id: string) => void;
  onRefetch?: () => void;
};

export const BrokeredOrderActionMenu: React.FC<
  BrokeredOrderActionMenuProps
> = ({ order, onVoid, onFinish, onRefetch }) => {
  const menuItems = useBrokeredOrderMenuItems({
    order,
    showVoidButton: true,
    showFinishButton: true,
    onVoid,
    onFinish,
    onRefetch,
    displayListActions: true,
  });

  if (menuItems.length === 0) return null;

  return (
    <div className="@BrokeredOrderActionMenu flex justify-center">
      <Menu
        trigger={
          <Button
            size="icon"
            icon={<MoreHorizontal className="size-4" />}
            variant="outline"
          />
        }
        items={menuItems}
      />
    </div>
  );
};
